import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button, Divider, Layout, Select, Space, Typography} from 'antd';
import {
    AudioOutlined,
    CameraOutlined,
    CheckCircleFilled,
    ClockCircleOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons';
import {useAuth} from "../../../providers/AuthProvider";
import {useNetworkState} from "react-use";

const { Header, Content, Sider } = Layout;
const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const InterviewSetup = ({showPermissionsError, hasPermissions,selectedAudioDevice, setSelectedAudioDevice, selectedVideoDevice, setSelectedVideoDevice, ...props }) => {
    const {auth} = useAuth();
    const localVideoRef = useRef();

    const {downlink, effectiveType} = useNetworkState();
    // const [audioPermissionsGranted, setAudioPermissionsGranted] = useState(null);
    // const [videoPermissionsGranted, setVideoPermissionsGranted] = useState(null);


    const [audioDevices, setAudioDevices] = useState([]);
    const [videoDevices, setVideoDevices] = useState([]);
    // const [hasPermissions, setHasPermissions] = useState(null);
    // const videoRef = useRef(null);

    // useEffect(() => {
    //     requestPermissions();
    // }, []);

    useEffect(() => {
        if (hasPermissions) {
            enumerateDevices();
        }
    }, [hasPermissions]);


    const enumerateDevices = async () => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter(device => device.kind === 'audioinput');
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        console.log('enumerateDevices', {videoDevices, audioDevices})
        setAudioDevices(audioDevices);
        setVideoDevices(videoDevices);
    };
    const totalTime = useMemo(() => (TB.sumBy(laravel.talent_video_interview_steps, 'target_length_seconds') || 180) / 60, []);

    return (
        <React.Fragment>
            <Space className="mb-4 flex flex-row flex-wrap justify-between" align="center">
                <Title level={3} className="m-0 whitespace-nowrap">Before you begin</Title>
                <div className="flex items-center">
                    <ClockCircleOutlined className="text-gray-400 mr-2"/>
                    <Text className="text-gray-400 whitespace-nowrap">{TB.pluralize('min', Math.ceil(totalTime), true)}</Text>
                    <QuestionCircleOutlined className="text-gray-400 mr-2 ml-3"/>
                    <Text className="text-gray-400 whitespace-nowrap">{laravel.talent_video_interview_steps?.length || '3'} questions</Text>
                </div>
            </Space>
            <Paragraph className="text-gray-600 mb-4">
                Set up your recording space with proper lighting and a clean background. You can retake as many times as you want!
            </Paragraph>

            <div className="flex gap-4 mb-6">
                <Button onClick={() => {

                    console.log('has', downlink,!hasPermissions)
                    if (!hasPermissions) {
                        return showPermissionsError()
                    }
                    return props.onStart()
                }} disabled={hasPermissions === null} type="primary" block className="bg-purple-600 hover:bg-purple-700 mx-auto max-w-[300px]">
                    Let's start
                </Button>
            </div>

            <Divider/>

            <Title level={4} className="mb-8">Let's check your setup</Title>

            <div className="space-y-8 flex flex-col items-stretch">
                <SetupItem
                    icon={CameraOutlined}
                    label="Device camera"
                    value={selectedVideoDevice}
                    empty={hasPermissions === null ? (
                        <span className="italic text-gray-400">Waiting for permission..</span>
                    ) : (!hasPermissions ? (
                        <span className="text-danger">
                            Permission not granted
                        </span>
                    ) : undefined)}
                    onChange={setSelectedVideoDevice}
                    options={videoDevices.map(device => ({label: device.label, value: device.deviceId}))}
                />
                <SetupItem
                    icon={AudioOutlined}
                    label="Microphone"
                    empty={hasPermissions === null ? (
                        <span className="italic text-gray-400">Waiting for permission..</span>
                    ) : (!hasPermissions ? (
                        <span className="text-danger">
                            Permission not granted
                        </span>
                    ) : undefined)}
                    value={selectedAudioDevice}
                    onChange={setSelectedAudioDevice}
                    options={audioDevices.map(device => ({label: device.label, value: device.deviceId}))}
                />
                <div className="flex flex-col items-stretch gap-2">
                    <div className="flex items-center flex-1 flex-nowrap min-w-0 gap-2">
                        <Text className="text-gray-700 whitespace-nowrap">Internet Connection</Text>
                    </div>
                    <Select
                        value={undefined}
                        showArrow={false}
                        bordered={false}
                        aria-readonly={true}
                        // style={{width: '300px'}}
                        className="flex items-center pointer-events-none"
                        placeholder={(
                            <div className="flex flex-row items-center">
                                {/*<WifiOutlined className="text-gray-400 mr-3 text-lg"/>*/}

                                {downlink < 0.5 ? (
                                    <span className="text-danger"><i className="fas fa-signal mr-1"/> Poor
                                        Connection</span>
                                ) : (downlink <= 1.5 ? (
                                    <span className="text-warning"><i className="fas fa-signal mr-1"/> Good</span>
                                ) : downlink <= 7.5 ? (
                                    <span className="text-green-500"><i className="fas fa-signal mr-1"/> Great
                                    </span>
                                ) : (
                                    <span className="text-success"><i className="fas fa-signal mr-1"/> Excellent
                                    </span>
                                ))}
                            </div>
                        )}
                        onChange={() => {
                        }}/>
                </div>
            </div>
        </React.Fragment>
    );
};
const SetupItem = ({complete,icon: Icon, label, value, onChange, options = [], empty, ...props}) => {

    return (
        <div className="flex flex-col items-stretch gap-2">
            <div className="flex items-center flex-1 flex-nowrap min-w-0 gap-2">
                <Text className="text-gray-700 whitespace-nowrap">{label}</Text>
            </div>
            <div className="flex flex-row flex-nowrap items-center gap-2">
                <Select
                    value={value}
                    style={{maxWidth: 400}}
                    className="flex-grow items-center"
                    placeholder={empty}
                    disabled={!options.length}
                    onChange={onChange}>
                    {options?.length > 0 && options.map(option => (
                        <Option key={option.value} value={option.value}>
                            <span className="flex flex-row items-center relative overflow-hidden">
                                <Icon className="text-gray-400 mr-3 text-lg"/>

                                <span className="text-ellipsis overflow-hidden whitespace-nowrap flex-grow">{option.label}</span>
                            </span>
                        </Option>
                    ))}
                </Select>
                <CheckCircleFilled style={{fontSize: 28}} className={!!value ? "text-success" :"text-gray-200"} />

            </div>
        </div>
    )
};

export default InterviewSetup;